var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffb718;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.5,0H51a0,0,0,0,1,0,0V25.5A25.5,25.5,0,0,1,25.5,51h0A25.5,25.5,0,0,1,0,25.5v0A25.5,25.5,0,0,1,25.5,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.224 9.898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.2,919.49a4.851,4.851,0,0,1-5.284,4.831,5.019,5.019,0,0,1-4.416-5.082V917.8a5.019,5.019,0,0,1,4.416-5.082,4.851,4.851,0,0,1,5.284,4.831Z",
    transform: "translate(-95.074 -912.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M112.378,926.141l-1.621,1.938a1.214,1.214,0,0,1-1.86,0l-1.621-1.938a2.4,2.4,0,0,0-2.772-.694,13.34,13.34,0,0,0-7.947,10.879,1.224,1.224,0,0,0,1.213,1.35h24.115a1.224,1.224,0,0,0,1.213-1.35,13.34,13.34,0,0,0-7.947-10.879A2.4,2.4,0,0,0,112.378,926.141Z",
    transform: "translate(-96.551 -910.031)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.995431504b645fbcdc55d562b1a4063f.svg";
export { ForwardRef as ReactComponent };